export const FACET_ORDER = ['style', 'color', 'price', 'photo', 'foil', 'orientation', 'format'] as const;
